import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environment/environment';

export const devOnlyGuard: CanActivateFn = () => {
	const router = inject(Router);

	if (environment.production) {
		router.navigate(['/login']);
		return false;
	}

	return true;
};
